import { AppDispatch } from 'app/store';
import { API_ENDPOINTS } from 'utils/constants';
import { deleteAPI, getAPI, postAPI } from 'services/api/apiAsync';
import { fetchUserDetails } from 'services/user/userAsync';
import { setPlanEntitlements } from './planSlice';
import { ICancelRequest } from './types';

export function cancelPlan(userId: string, requestReason: ICancelRequest) {
  return async (dispatch: AppDispatch) => {
    try {
      const config = {
        url: `${API_ENDPOINTS.userProfile}/${userId}`,
        data: requestReason,
      };
      const response = await dispatch(deleteAPI(config)).unwrap();
      await dispatch(fetchUserDetails(userId));
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

export function getUserPlan() {
  return async (dispatch: AppDispatch) => {
    try {
      const config = {
        url: `${API_ENDPOINTS.planDetails}`,
      };
      const response = await dispatch(getAPI(config)).unwrap();

      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

export function findPlanDetails(planCode: string) {
  return async (dispatch: AppDispatch) => {
    try {
      const config = {
        url: API_ENDPOINTS.findPlan,
        data: {
          plan_code: planCode,
        },
      };
      const response = await dispatch(postAPI(config)).unwrap();
      if (response[0]?.entitlements) {
        dispatch(setPlanEntitlements(response[0].entitlements));
      }
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
